import React, { useId, useState } from 'react';
import './CompetesAsField.css';

// Required competition gender when someone signs up themselves or a child.
// The (i) toggles a short explanation, so it works on touch screens too.
export default function CompetesAsField({ value, onChange, self = false, style }) {
  const [showInfo, setShowInfo] = useState(false);
  const selectId = useId();
  const options = self
    ? [{ value: 'FEMALE', label: 'Women' }, { value: 'MALE', label: 'Men' }]
    : [{ value: 'FEMALE', label: 'Girls' }, { value: 'MALE', label: 'Boys' }];

  return (
    <div className="competes-as" style={style}>
      <div className="competes-as__head">
        <label htmlFor={selectId} className="bk-label competes-as__label">Competes as</label>
        <button
          type="button"
          className="competes-as__info"
          aria-label="What does competes as mean?"
          aria-expanded={showInfo}
          onClick={() => setShowInfo(v => !v)}
        >
          i
        </button>
      </div>
      {showInfo && (
        <p className="competes-as__help">
          The gender {self ? 'you' : 'they'} would compete as. Competitions run separate {self ? "women's and men's" : "girls' and boys'"} events, and this puts {self ? 'you' : 'them'} in the right ones.
        </p>
      )}
      <select id={selectId} className="bk-input" value={value} onChange={e => onChange(e.target.value)} required>
        <option value="">Choose...</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}
